'use client';

import { Timeline } from './containers/Timeline';

export default function Index() {
  return (
    <div className="bg-gray-900 text-white min-h-screen">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center mb-8 p-4 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600">
          Protecting crypto, one wallet at a time.
        </h1>
        <div className="border-t border-gray-700 pt-4">
          <div className="top-4">
            <h2 className="text-3xl font-bold mb-2">Roadmap</h2>
            <h4 className="text-base text-gray-500 mb-4">
              We're in this for the long haul, so we wanted to fill you in on the next steps for our
              project.
            </h4>
          </div>
          <Timeline />
        </div>
      </div>
    </div>
  );
}
